import { createSlice } from "@reduxjs/toolkit";

export interface ResponderState {
    locations: any[]
    baseLocation: string
}
const initialState: ResponderState = {
    locations: [],
    baseLocation:''
}

const locationSlice = createSlice({
    name: "locations",
    initialState,
    reducers: {
        setLocations: (state: ResponderState, actions) => {
            state.locations = actions.payload;
        },
        setBaseLocation: (state: ResponderState, actions) => {
            state.baseLocation = actions.payload;
        }
    },

});

export const { setLocations ,setBaseLocation} =
    locationSlice.actions;
export default locationSlice.reducer;